import { Skeleton } from '@common/components';

export const MainCarouselSkeleton = () => {
  return (
    <div className="relative">
      <div className="px-10">
        <div className="px-10">
          <Skeleton className="aspect-[335/120] min-h-120 w-full rounded-large" />
        </div>
      </div>
      <Skeleton className="absolute bottom-16 right-36 h-20 w-40 rounded-pill" />
    </div>
  );
};
